import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * DatePicker Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Display format
     */
    @Prop({ default: 'yyyy-MM-dd' }) displayFormat!: string;

    /**
     * Input format
     */
    @Prop({ default: 'YYYY-MM-DD' }) inputFormat!: string;

    /**
     * Input Value Format
     */
    @Prop({ default: 'YYYY/MM/DD' }) format!: string;

    /**
     * Input Picker Type
     * Available Types: date | datetime | year | month | time
     */
    @Prop({ default: 'date' }) type!: string;

    /**
     * Calendar types
     */
    @Prop() calendar!: Array<string>;

    /**
     * Multiple selection
     */
    @Prop({ type: Boolean }) multiple!: boolean;

    /**
     * Change minutes by step
     */
    @Prop({ default: 1 }) jumpMinute!: number;

    /**
     * Round minutes when jumpMinute is grater than 1
     * when jumpMinute = 15 this will result: 13:00, 13:15, 13:30, 13:45 ...
     */
    @Prop({ type: Boolean }) roundMinute!: boolean;

    /**
     * String separator, used in multiple mode
     */
    @Prop({ default: ' - ' }) separator!: string;

    /**
     * Auto Submit Picker
     */
    @Prop({ type: Boolean }) autoSubmit!: boolean;

    /**
     * Auto submit when clicking the wrapper
     */
    @Prop({ type: Boolean }) wrapperSubmit!: boolean;

    /**
     * Popover Mode
     */
    @Prop({ type: Boolean }) popover!: boolean;

    /**
     * Compact Time Mode
     * Display Time and Date picker at the same page
     */
    @Prop({ type: Boolean }) compactTime!: boolean;

    /**
     * Minimum datetime
     */
    @Prop() min!: string;

    /**
     * Maximum datetime
     */
    @Prop() max!: string;

    /**
     * Show addon for input
     * 
     * TODO: Remove default value when backend support this prop
     */
    @Prop({ type: Boolean, default: true }) hasAddon!: boolean;

    /**
     * Add Clearable Option to input
     */
    @Prop({ type: Boolean }) clearable!: boolean;

    /**
     * Step to view on startup
     * Available views: day|month|year|time
     */
    @Prop({ default: 'day' }) viewOnStartup!: string;

    /**
     * Disabling some dates or items
     * 
     * ['1397/02/02', '1390/10/10'] | 1397/05/20 | /1397\/05\/(.*)/
     */
    @Prop({ default: 'day' }) disableDates!: string;

    /**
     * Highlight
     * This option only accepts function that must return an object of attributes.
     */
    @Prop() highlight!: Function;

    /**
     * Color of the Date Picker
     */
    @Prop({ default: '#10C290' }) pickerColor!: string;

    /**
     * Inline mode
     * Always show the date picker
     */
    @Prop({ type: Boolean }) inline!: boolean;

    /**
     * Timezone configuration
     * Examples: true | false | +03:30 | +04:30
     */
    @Prop() timezone!: string | Boolean | Function;

    /**
     * Show Now Button
     */
    @Prop({ type: Boolean }) showNowButton!: boolean;

    /**
     * Enable or disable range mode
     */
    @Prop({ type: Boolean }) range!: boolean;
    
    /**
     * Simple Mode
     */
    @Prop({ type: Boolean }) simple!: boolean;
}

export default Props;
